import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import ProfessionalDetails from "./ProfessionalDetails";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class AreasOfInterest extends Component {

validateForm(){
  return true;
}

constructor(props){
  super(props);
  this.state = {
      errorMsg: "",
      successMsg: "",
      isLoading: false,
      uveaState: this.getCheckedState("uvea"),
      vitreoretinaState: this.getCheckedState("vitreoretina"),
      medicalretinaState: this.getCheckedState("medicalretina"),
      ocularoncologyState: this.getCheckedState("ocularoncology"),
      neuroopthalmologyState: this.getCheckedState("neuroopthalmology"),
      otherinterestsState: this.getCheckedState("otherinterests")

  };
}

getCheckedState(propertyName){
  var propName = propertyName + "State";
  if(this.props.userProfile[propertyName] && this.props.userProfile[propertyName].length > 0){
    var checkedState = this.props.userProfile[propertyName] === "true" ? true : false;
    return checkedState;
  }
  return false;
}


handleChange = event => {
  this.setState({

    [event.target.id+"State"]: !this.state[event.target.id+"State"],
    [event.target.id]: !this.state[event.target.id+"State"]+"",
     successMsg: "",
     errorMsg: ""
  });
}


submitDetails = async event => {

    event.preventDefault();
    this.setState({ isLoading: true});
    try{
      await this.props.updateUserProfile(this.state);
      this.setState({isLoading: false, successMsg: "Successfully updated your interests."});
    }catch(e){
      this.setState({isLoading: false, errorMsg: e.message});
    }
 }

  getSuccessNotification(successMsg){
    return this.state.successMsg && this.state.successMsg.length > 0
                            ? <div className="alert alert-success" role="alert">
                                {this.state.successMsg}
                              </div>
                            : "";
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div className="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

render() {
    return(
      <div className="container">
            <br />
            <div className="row cols-xs-space cols-sm-space cols-md-space">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-lg-2"></div>
                      <div className="col-lg-8 profile-udpate-widget">
                          <div className="card">
                              <div className="card-title b-xs-bottom">
                                  <h3 className="heading heading-sm text-uppercase">Areas Of Interest</h3>

                              </div>

                              <div className="card-body">

                                <form id="areasOfInterstForm"
                                  onSubmit={this.submitDetails}>
                                  <div className="row">
                                      <div className="col-md-4">
                                          <div className="checkbox">
                                            <input type="checkbox"
                                                   name="vitreoretina"
                                                   onChange={this.handleChange}
                                                   checked ={this.state.vitreoretinaState}
                                                   id="vitreoretina" />
                                              <label for="vitreoretina">
                                                  Vitreo Retina
                                             </label>
                                         </div>
                                      </div>
                                      <div className="col-md-5">
                                           <div className="checkbox">
                                              <input type="checkbox"
                                                     name="medicalretina"
                                                     onChange={this.handleChange}
                                                     checked={this.state.medicalretinaState}
                                                     id="medicalretina" />

                                              <label for="medicalretina">
                                                   Medical Retina
                                              </label>
                                           </div>
                                     </div>
                                     <div className="col-md-3">
                                        <div className="checkbox">
                                         <input type="checkbox"
                                                name="uvea"
                                                onChange={this.handleChange}
                                                checked={this.state.uveaState}
                                                id="uvea" />
                                           <label for="uvea">
                                               Uvea
                                          </label>
                                        </div>
                                    </div>
                                  </div>

                                 <div className="row">
                                     <div className="col-md-4">
                                         <div className="checkbox">
                                           <input type="checkbox"
                                                  name="ocularoncology"
                                                  onChange={this.handleChange}
                                                  checked={this.state.ocularoncologyState}
                                                  id="ocularoncology" />
                                             <label for="ocularoncology">
                                                 Ocular Oncology
                                            </label>
                                        </div>
                                     </div>
                                     <div className="col-md-5">
                                          <div className="checkbox">
                                             <input type="checkbox"
                                                    name="neuroopthalmology"
                                                    onChange={this.handleChange}
                                                    checked={this.state.neuroopthalmologyState}
                                                   id="neuroopthalmology" />
                                             <label for="neuroopthalmology">
                                                  Neuro Opthalmology
                                             </label>
                                          </div>
                                    </div>
                                    <div className="col-md-3">
                                         <div className="checkbox">
                                               <input type="checkbox"
                                                       name="otherinterests"
                                                        onChange={this.handleChange}
                                                         checked={this.state.otherinterestsState}
                                                       id="otherinterests" />
                                               <label for="otherinterests">
                                                    Other
                                               </label>
                                         </div>
                                   </div>
                                 </div>

                                  <br/>
                                  <div className="form-group align-center">

                                      <LoaderButton block bsStyle="primary" bsSize="large"
                                            disable={!this.validateForm()} type="submit"
                                            isLoading={this.state.isLoading} text=" Update "
                                            loadingText="Updating Details..."
                                            className="btn btn-primary"/>
                                  </div>
                                </form>
                                {this.getErrorElement()}
                                {this.getSuccessNotification()}

                              </div>
                          </div>
                      </div>
                      <div className="col-lg-2"></div>
                    </div>

                  </div>
            </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/AreasOfInterest.js